/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type {
  OffsetDateTime,
  LocalDate,
} from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { CompanyDocumentType } from "./CompanyDocumentType";
import {
  CompanyDocumentTypeFromJSON,
  CompanyDocumentTypeFromJSONTyped,
  CompanyDocumentTypeToJSON,
  CompanyDocumentTypeToJSONTyped,
} from "./CompanyDocumentType";

/**
 *
 * @export
 * @interface CompanyDocument
 */
export interface CompanyDocument {
  /**
   *
   * @type {string}
   * @memberof CompanyDocument
   */
  companyDocumentId?: string;
  /**
   *
   * @type {string}
   * @memberof CompanyDocument
   */
  companyId?: string;
  /**
   *
   * @type {string}
   * @memberof CompanyDocument
   */
  customerSpecificPricingAgreementId?: string;
  /**
   *
   * @type {CompanyDocumentType}
   * @memberof CompanyDocument
   */
  documentType?: CompanyDocumentType;
  /**
   *
   * @type {string}
   * @memberof CompanyDocument
   */
  documentName?: string;
  /**
   *
   * @type {string}
   * @memberof CompanyDocument
   */
  documentS3Key?: string;
  /**
   *
   * @type {string}
   * @memberof CompanyDocument
   */
  thumbnailS3Key?: string;
  /**
   *
   * @type {string}
   * @memberof CompanyDocument
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof CompanyDocument
   */
  contentType?: string;
  /**
   *
   * @type {boolean}
   * @memberof CompanyDocument
   */
  isCurrent?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CompanyDocument
   */
  isSigned?: boolean;
  /**
   *
   * @type {LocalDate}
   * @memberof CompanyDocument
   */
  dateReceived?: LocalDate;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof CompanyDocument
   */
  uploadedAt?: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof CompanyDocument
   */
  uploadedBy?: string;
}

/**
 * Check if a given object implements the CompanyDocument interface.
 */
export function instanceOfCompanyDocument(
  value: object,
): value is CompanyDocument {
  return true;
}

export function CompanyDocumentFromJSON(json: any): CompanyDocument {
  return CompanyDocumentFromJSONTyped(json, false);
}

export function CompanyDocumentFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CompanyDocument {
  if (json == null) {
    return json;
  }
  return {
    companyDocumentId:
      json["companyDocumentId"] == null ? undefined : json["companyDocumentId"],
    companyId: json["companyId"] == null ? undefined : json["companyId"],
    customerSpecificPricingAgreementId:
      json["customerSpecificPricingAgreementId"] == null
        ? undefined
        : json["customerSpecificPricingAgreementId"],
    documentType:
      json["documentType"] == null
        ? undefined
        : CompanyDocumentTypeFromJSON(json["documentType"]),
    documentName:
      json["documentName"] == null ? undefined : json["documentName"],
    documentS3Key:
      json["documentS3Key"] == null ? undefined : json["documentS3Key"],
    thumbnailS3Key:
      json["thumbnailS3Key"] == null ? undefined : json["thumbnailS3Key"],
    description: json["description"] == null ? undefined : json["description"],
    contentType: json["contentType"] == null ? undefined : json["contentType"],
    isCurrent: json["isCurrent"] == null ? undefined : json["isCurrent"],
    isSigned: json["isSigned"] == null ? undefined : json["isSigned"],
    dateReceived:
      json["dateReceived"] == null ? undefined : json["dateReceived"],
    uploadedAt: json["uploadedAt"] == null ? undefined : json["uploadedAt"],
    uploadedBy: json["uploadedBy"] == null ? undefined : json["uploadedBy"],
  };
}

export function CompanyDocumentToJSON(json: any): CompanyDocument {
  return CompanyDocumentToJSONTyped(json, false);
}

export function CompanyDocumentToJSONTyped(
  value?: CompanyDocument | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    companyDocumentId: value["companyDocumentId"],
    companyId: value["companyId"],
    customerSpecificPricingAgreementId:
      value["customerSpecificPricingAgreementId"],
    documentType: CompanyDocumentTypeToJSON(value["documentType"]),
    documentName: value["documentName"],
    documentS3Key: value["documentS3Key"],
    thumbnailS3Key: value["thumbnailS3Key"],
    description: value["description"],
    contentType: value["contentType"],
    isCurrent: value["isCurrent"],
    isSigned: value["isSigned"],
    dateReceived: value["dateReceived"],
    uploadedAt: value["uploadedAt"],
    uploadedBy: value["uploadedBy"],
  };
}
